import { Content } from "@/ui";
import { getRoute } from "@/functions/getRoute";
import { createTitle } from "@/functions/createTitle";
import * as additionalComponents from "./__components";

export default function BlogsPage({ content }) {
  return (
    <>
      <Content items={content} additionalComponents={additionalComponents} />
    </>
  );
}

export async function getStaticProps() {
  return {
    props: {
      meta: {
        title: "Legal Blogs", // createTitle("Blog"),
      },
      content: [
        {
          component: "BreadcrumbNavigation",
          props: {
            items: [
              {
                label: "Legal Blogs",
                href: getRoute("blog"),
              },
            ],
          },
        },
        {
          component: "Header",
          props: {
            className: "bg-primary text-white",
            title: {
              path: "page.blogs.component.Header.title",
              placeholder: "Legal Blogs",
            },
            description: {
              path: "page.blogs.component.Header.description",
              placeholder: "",
            },
            // img: { path: "page.blog.component.Header.image", alt: "Blogs Page Header", size: "1440x360" },
          },
        },
        {
          component: "BlogFeed",
        },
      ],
    },
  };
}
